module.exports = __webpack_public_path__ + "img/NextDayPickup.54ad4e42.svg";